import Reveal from "./Reveal";

export default function SectionHeading({ eyebrow, title, sub, light = false, testId }) {
  return (
    <Reveal>
      <p className={`text-xs font-bold uppercase tracking-[0.22em] ${light ? "text-[#9CC3F0]" : "text-[#A87B1F]"}`} data-testid={testId ? `${testId}-eyebrow` : undefined}>
        {eyebrow}
      </p>
      <h2 className={`mt-3 max-w-2xl text-balance text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${light ? "text-white" : "text-[#0B1F3A]"}`} data-testid={testId ? `${testId}-title` : undefined}>
        {title}
      </h2>
      {sub && (
        <p className={`mt-4 max-w-2xl text-base leading-relaxed ${light ? "text-white/65" : "text-[#667085]"}`}>
          {sub}
        </p>
      )}
    </Reveal>
  );
}
